import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const TransactionLinkRenderer = (props) => {
  return (
    <Link to={`/booking/car/${props.data.id}`}>{props.value}</Link>
  );
};

TransactionLinkRenderer.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }).isRequired,
  value: PropTypes.node
};

export default TransactionLinkRenderer;
